"use client";

import React from "react";
import styles from "./GlobalLoader.module.scss";
import PlatformLoader from "@components/atoms/PlatformLoader/PlatformLoader";
import ValuationLoader from "@components/atoms/ValuationLoader";
import type { LoaderVariant } from "@context/LoadingContext";

interface GlobalLoaderProps {
  isLoading?: boolean;
  className?: string;
  overlayClassName?: string;
  textClassName?: string;
  size?: "small" | "medium" | "large";
  variant?: LoaderVariant;
  overlay?: boolean;
  text?: string;
  lottieWidth?: number;
  lottieHeight?: number;
}

const GlobalLoader: React.FC<GlobalLoaderProps> = ({
  isLoading = true,
  className = "",
  overlayClassName = "",
  textClassName = "",
  size = "small",
  variant = "spinner",
  overlay = false,
  text = "Loading...",
  lottieWidth,
  lottieHeight,
}) => {
  if (!isLoading) return null;

  const getLoaderDimensions = () => {
    const fallbackSizeMap = {
      small: 80,
      medium: 120,
      large: 120,
    };
    const fallbackSize = fallbackSizeMap[size];

    return {
      width: lottieWidth || fallbackSize,
      height: lottieHeight || fallbackSize,
    };
  };
  const loaderDimensions = getLoaderDimensions();

  const loaderContent = (
    <div className={`${styles.loaderContainer} ${className}`}>
      {variant === "spinner" && (
        <div className={`${styles.spinner} ${styles[size]}`}>
          <div className={styles.spinnerInner}></div>
        </div>
      )}

      {variant === "dots" && (
        <div className={`${styles.dots} ${styles[size]}`}>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
        </div>
      )}

      {variant === "pulse" && (
        <div className={`${styles.pulse} ${styles[size]}`}></div>
      )}

      {variant === "lottie" && (
        <div className={styles.lottieContainer}>
          <PlatformLoader
            width={loaderDimensions.width}
            height={loaderDimensions.height}
            loop={true}
            autoplay={true}
            className={styles.lottieLoader}
          />
        </div>
      )}

      {variant === "valuation" && (
        <ValuationLoader
          width={loaderDimensions.width}
          height={loaderDimensions.height}
          loop={true}
          autoplay={true}
        />
      )}

      {text && (
        <div className={`${styles.loaderText} ${textClassName}`}>
          {text}
        </div>
      )}
    </div>
  );

  if (overlay) {
    return (
      <div className={`${styles.overlay} ${overlayClassName}`}>
        {loaderContent}
      </div>
    );
  }

  return loaderContent;
};

export default GlobalLoader;
